// extracted by mini-css-extract-plugin
export var container = "_fx-1";
export var editor = "_fx-2";
export var resizable = "_fx-3";
export var wrapper = "_fx-0";